module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='button js-modal-close medium transparent'>Cancel</div>\n<button class='" + (['button', 'medium', 'primary', 'js-save', ($e($c(!this.formValid ? 'disable' : void 0))) + " " + ($e($c(this.hideChoose ? 'hidden' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' type='button'>Choose</button>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/platform/templates/assets/asset_picker_actions.js.hamlc
// module id = 1553
// module chunks = 18